import iconClock from "../../../../assets/icon_as_clock.svg";
import iconMap from "../../../../assets/icon_as_map.svg";
import iconTel from "../../../../assets/icon_as_tel.svg";
import iconHome from "../../../../assets/icon_as_home.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import useReactGASend from "../../../../hooks/useReactGASend";
import useAsAgentSearch from "#features/AfterService/hooks/useAsAgentSearch";

const ContactItem = ({ iconSrc, children, link, onClick }) => {
  const content = (
    <>
      <span className="flex items-center justify-center w-8 h-8 rounded-full bg-neutral-100 shrink-0">
        <img src={iconSrc} alt="" />
      </span>
      <p className="leading-8">{children}</p>
    </>
  );

  return (
    <li className="flex gap-2.5 font-medium text-neutral-500 leading-7">
      {link ? (
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="flex gap-2.5 items-center"
          onClick={onClick}
        >
          {content}
        </a>
      ) : (
        <div className="flex gap-2.5 items-center">{content}</div>
      )}
    </li>
  );
};

const formatHomepageLink = (homepage) => {
  if (homepage.startsWith("http://") || homepage.startsWith("https://")) {
    return homepage;
  }
  if (homepage.startsWith("www.")) {
    return `http://${homepage}`;
  }
  return undefined;
};

const AfterServiceList = ({ agentList, infinity, fetchMoreData, formData }) => {
  const { makeEventTrackFn } = useReactGASend();

  const trackLinkClick = (title, body) => {
    makeEventTrackFn({
      category: "event",
      action: title,
      body,
    });
  };
  return (
    <InfiniteScroll
      dataLength={agentList.length}
      next={fetchMoreData}
      hasMore={infinity}
      loader={<></>}
    >
      <ul className="flex flex-col">
        {agentList?.map(
          ({
            id,
            corp_name,
            corp_homepage,
            corp_telno,
            corp_addr,
            keyword,
            op1_gubun,
            op1_time,
            op2_gubun,
            op2_time,
          }) => {
            const keywordsArray = keyword.split(",").filter(Boolean);
            const homepageLink = formatHomepageLink(corp_homepage);

            return (
              <li className="border-b py-7" key={id + corp_name}>
                <h3 className="text-xl font-semibold mb-2.5">{corp_name}</h3>
                {keywordsArray.length > 0 && (
                  <ul className="inline-flex items-center gap-2 px-3.5 py-1 mb-5 bg-neutral-100 rounded-[19px] flex-wrap">
                    {keywordsArray.map((word, index) => (
                      <li
                        key={index}
                        className="text-xs font-semibold text-purple-c-100"
                      >
                        #{word.trim()}
                      </li>
                    ))}
                  </ul>
                )}
                <ul className="flex flex-col gap-1">
                  {(op1_gubun || op1_time || op2_gubun || op2_time) && (
                    <ContactItem iconSrc={iconClock}>
                      {op1_gubun} {op1_time} {op2_gubun && "/ "} {op2_gubun}{" "}
                      {op2_time}
                    </ContactItem>
                  )}
                  {corp_addr && (
                    <ContactItem iconSrc={iconMap}>{corp_addr}</ContactItem>
                  )}
                  {corp_telno && (
                    <ContactItem
                      iconSrc={iconTel}
                      link={`tel:${corp_telno}`}
                      onClick={() =>
                        trackLinkClick("서비스센터 안내(전화 연결)", {
                          data_keyword: formData.keyword,
                          data_btn_nm: `${corp_name}(전화 연결)`
                        })
                      }
                    >
                      {corp_telno}
                    </ContactItem>
                  )}
                  {corp_homepage && corp_homepage.trim() !== "" && (
                    <ContactItem
                      iconSrc={iconHome}
                      link={homepageLink}
                      onClick={() => {
                        trackLinkClick("서비스센터 안내(사이트 연결)", {
                          data_keyword: formData.keyword,
                          data_btn_nm: `${corp_name}(사이트 연결)`
                        });
                      }}
                    >
                      {homepageLink ? (
                        <span>{corp_homepage}</span>
                      ) : (
                        <span>{corp_homepage}</span>
                      )}
                    </ContactItem>
                  )}
                </ul>
              </li>
            );
          }
        )}
      </ul>
    </InfiniteScroll>
  );
};

export default AfterServiceList;
